import { Trans, useTranslation } from '@wix/fe-essentials-standalone/i18n';
import { Text, TextButton } from '@wix/design-system';
import { EmptyStateBanner } from '../EmptyStateBanner';
import { useCallback, useEffect } from 'react';
import { useTemplatesContext } from '@components/Contexts/TemplatesContext';
import { useShallowRouter } from '@components/Hooks/useRouter';
import { updateQueryParams } from '@utils/route';
import { useTemplatesBi } from '@components/Hooks/useTemplatesBi';

export const NoSearchResultsBanner = ({
  isMobileView,
}: {
  isMobileView?: boolean;
}) => {
  const { t } = useTranslation();
  const {
    state: { filters },
    templateSearchFieldRef,
  } = useTemplatesContext();
  const searchTerm = filters?.search;
  const { navigate, router } = useShallowRouter();
  const { logBiPageView } = useTemplatesBi({});

  const onClickTryDifferentSearch = useCallback(() => {
    templateSearchFieldRef?.current?.focus();
  }, [templateSearchFieldRef?.current]);

  const onClickBrowseTemplatesGallery = useCallback(() => {
    navigate(
      updateQueryParams({}, router, {
        all: true,
      }),
    );
  }, []);

  const titleText = t(
    'marketplace.templates-page.empty-state.search-no-matches-title',
    { searchTerm },
  );
  const textSize = isMobileView ? 'small' : 'medium';

  useEffect(() => {
    logBiPageView({ message_text: titleText });
  }, []);

  return (
    <EmptyStateBanner title={titleText} isMobileView={isMobileView}>
      <Trans i18nKey="marketplace.templates-page.empty-state.search-no-matches-subtitle">
        <Text size={textSize} weight="thin" secondary>
          {'0 '}
          <TextButton size={textSize} onClick={onClickTryDifferentSearch}>
            1
          </TextButton>
          <TextButton size={textSize} onClick={onClickBrowseTemplatesGallery}>
            2
          </TextButton>
        </Text>
      </Trans>
    </EmptyStateBanner>
  );
};
